/**
 * Barra de progresso dos carrosséis da home (mobile): vitrines de produto
 * e tiles de marcas compartilham o mesmo contrato (trilho rolável +
 * [data-shelf-progress] no mesmo escopo).
 *
 * Progressive enhancement: sem JavaScript a barra mostra um estado
 * estático inicial (já comunica que há continuação); com JavaScript o
 * indicador acompanha a rolagem e some quando não há overflow.
 * Delegação no document + guard de idempotência (padrão do projeto).
 */
(function () {
  'use strict';

  if (window.SuplementariaShelfProgressInitialized) return;
  window.SuplementariaShelfProgressInitialized = true;

  function isTrack(el) {
    return el.classList.contains('product-shelf__grid') || el.classList.contains('brands__tiles');
  }

  function update(grid) {
    var scope = grid.closest('.product-shelf, .brands');
    if (!scope) return;
    var bar = scope.querySelector('[data-shelf-progress]');
    var nav = scope.querySelector('[data-shelf-nav]');
    var max = grid.scrollWidth - grid.clientWidth;
    if (max < 8) {
      // grade desktop ou poucos itens: sem indicador nem setas
      if (bar) bar.hidden = true;
      if (nav) nav.hidden = true;
      return;
    }
    if (bar) {
      bar.hidden = false;
      bar.style.setProperty('--shelf-progress', grid.scrollLeft / max);
      bar.style.setProperty('--shelf-visible', grid.clientWidth / grid.scrollWidth);
    }
    if (nav) {
      nav.hidden = false;
      var prev = nav.querySelector('[data-shelf-prev]');
      var next = nav.querySelector('[data-shelf-next]');
      if (prev) prev.disabled = grid.scrollLeft < 8;
      if (next) next.disabled = grid.scrollLeft > max - 8;
    }
  }

  function updateAll() {
    document.querySelectorAll('.product-shelf__grid, .brands__tiles').forEach(update);
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (target instanceof Element && isTrack(target)) {
        update(target);
      }
    },
    true
  );

  // Setas: rolam uma "tela" do trilho; estados atualizados pelo scroll
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var btn = event.target.closest('[data-shelf-prev], [data-shelf-next]');
    if (!btn || btn.disabled) return;
    var scope = btn.closest('.product-shelf, .brands');
    if (!scope) return;
    var track = scope.querySelector('.product-shelf__grid, .brands__tiles');
    if (!track) return;
    var direction = btn.hasAttribute('data-shelf-prev') ? -1 : 1;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: direction * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  window.addEventListener('resize', updateAll);
  document.addEventListener('shopify:section:load', updateAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();
